module.exports = "/_next/static/images/Andrei_Ureche-7b96dbf5ab41daf6efb4356a4f473578.webp";